import React from "react";
import { User, Star, Crown, Truck } from "lucide-react";
import ProcessStep from "./ProcessStep";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const ProcessSection = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData =
    labels.menuPages?.buyCar?.accountBenefitsProcessSection || {};
  const stepsData = sectionData.steps || [];

  const icons = [User, Star, Crown, Truck];

  const processSteps = stepsData.map((step: any, index: number) => {
    const Icon = icons[index] || icons[0];
    return {
      icon: <Icon className="w-6 h-6" />,
      title: step.title || "",
      desc: step.desc || "",
    };
  });

  return (
    <div className="bg-white rounded-3xl p-8 shadow-lg max-w-4xl mx-auto">
      <h3 className="text-2xl font-bold text-center text-gray-900 mb-8">
        {sectionData.title || "Så Enkelt Köper Du Din Bil"}
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {processSteps.map((step, index) => (
          <ProcessStep key={index} step={step} index={index} />
        ))}
      </div>

      <div className="mt-8 text-center px-4">
        <img
          src="/assets/bidding_example.png"
          alt="Auktionssida med budgivning och fordonsdetaljer"
          className="mx-auto rounded-lg shadow-md max-w-2xl w-full"
        />
      </div>
    </div>
  );
};

export default ProcessSection;
